import { Hammer } from 'lucide-react';
import { Cabecalho } from '../componentes/Cabecalho';
import { Vazio } from '../componentes/Estados';

/**
 * Placeholder honesto: diz em qual sprint o módulo entra, em vez de fingir que
 * a tela existe e está vazia.
 */
export function EmConstrucao({
  titulo,
  descricao,
  sprint,
  bloqueio,
}: {
  titulo: string;
  descricao: string;
  sprint: string;
  bloqueio?: string;
}) {
  return (
    <div className="flex flex-col gap-6">
      <Cabecalho titulo={titulo} descricao={descricao} />
      <Vazio
        icone={<Hammer className="size-8" />}
        titulo={`Este módulo entra na ${sprint}`}
        descricao={
          bloqueio ?? 'A estrutura, as regras de segurança e o motor de cálculo já estão prontos. Falta a tela.'
        }
      />
    </div>
  );
}
